import React, {useEffect, useState} from "react";
import {sessionMessageService} from "./_services/sessionMessage.service";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock} from "@fortawesome/free-solid-svg-icons";
import OverlapDialog from "./OverlapDialog";
import {skip} from "rxjs/internal/operators/skip";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import {Box, Button} from "@material-ui/core";
import {useForm} from "react-hook-form";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import auth from "./Authenticate";
import { toast } from "react-toastify";

const useStyles = makeStyles(theme => ({
    form: {
        width: '100%', // Fix IE 11 issue.
    }
}));

const LoginModalComponent = () => {
    const [state, setState] = useState({open: false, isLoading: false});
    const { handleSubmit, register, errors } = useForm();
    const classes = useStyles();

    useEffect(() => {
        const subscription = sessionMessageService.loginModalService().pipe(skip(1)).subscribe((v) => {
            setState(state => ({...state, open: true, username: v.username}));
        });
        return () => subscription.unsubscribe();
    }, []);

    const handleDialogClose = () => {

    }

    const onSubmit = (credentials) => {
        setState(state => ({...state, isLoading: true}));
        auth.login(state.username, credentials.password)
            .then(response => {
                setState(state => ({...state, open: false, isLoading: false}));
            }).catch((error) => {
                console.log(error);
                toast.error('Proszę spróbować ponownie');
                setState(state => ({...state, isLoading: false}));
            });
    }

    return (
        <OverlapDialog
            title={<strong>Zaloguj się</strong>}
            open={state.open}
            draggable={true}
            maxWidth="xs"
            handleDialogClose={handleDialogClose}
            overlapContent={<FontAwesomeIcon
                aria-label={"fa-far-clock"} size="2x"
                icon={faClock}
            />}
        >
            <>
                <form method="post" className={classes.form} onSubmit={handleSubmit(onSubmit)} noValidate>
                    <Box component="div" >
                        <TextField
                            error={(errors.username && errors.username.message) !== undefined}
                            inputProps={
                                { readOnly: true, }
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            id="username"
                            label="Użytkownik"
                            name="username"
                            autoComplete="off"
                            defaultValue={state.username}

                        />
                        <Typography color="error" variant="caption" display="block" gutterBottom>
                            {errors.username && errors.username.message}
                        </Typography>
                        <TextField
                            error={(errors.password && errors.password.message) !== undefined}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            name="password"
                            label="Hasło"
                            type="password"
                            id="password"
                            autoComplete="off"
                            autoFocus
                            inputRef={register({ required: 'Proszę wprowadzić hasło' })}
                        />
                        <Typography color="error" variant="caption" display="block" gutterBottom>
                            {errors.password && errors.password.message}
                        </Typography>
                    </Box>
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        alignContent="center"
                        spacing={1}
                    >
                        <Grid item xs={4}>
                            <Button
                                className={classes.submitButton}
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                id="button-login-submit"
                            >
                                {state.isLoading && <CircularProgress color="secondary" size={24} />}
                                &nbsp;Login
                            </Button>

                        </Grid>
                    </Grid>
                </form>
            </>
        </OverlapDialog>
    )

};

export default LoginModalComponent;